import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { IconButton, DialogActions, Button as Button_1, MenuItem, TextField, Alert, Typography, DialogContent, DialogTitle, Dialog } from "@mui/material";
import { toArray, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Documents_DocumentSource, Documents_DocumentSource__get_Id } from "../../Shared/Shared.js";
import { uncurry2, createObj, defaultOf } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { unwrap, map as map_1, defaultArg, some, value as value_63 } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { map } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { disabledTooltip, loadingIndicatorSmall, errorBanner } from "../../ViewHelpers.js";
import { cons, empty as empty_1, ofArray } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { obj_type, anonRecord_type, string_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { GenericResponse_$reflection } from "../../Shared/ApiDataTypes.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../../Promises.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Message, documentsCtx, dispatchCtx } from "../../Documents/DocumentContext.js";
import Delete from "@mui/icons-material/Delete";

export function Form(formInputProps) {
    let elements_2, elements, children;
    const document$ = formInputProps.document;
    const onClose = formInputProps.onClose;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const reasonRef = reactApi.useRef(undefined);
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const errMsg = patternInput_1[0];
    const reasons = [ctx.Locale.t("Document.DeleteReasons.WrongDocument"), ctx.Locale.t("Document.DeleteReasons.WrongMachine"), ctx.Locale.t("Document.DeleteReasons.Expired"), ctx.Locale.t("Document.DeleteReasons.Replaced"), ctx.Locale.t("Document.DeleteReasons.Other")];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Document.Delete")]]), MuiHelpers_createElement(DialogContent, [["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 15 + "px",
    }], (elements = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "body1"], ["children", (document$.SourceId === Documents_DocumentSource__get_Id(new Documents_DocumentSource(0, []))) ? ((ctx.Locale.t("Document.DeleteDesc1", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["documentName", document$.Title])) + " ") + ctx.Locale.t("Document.DeleteDescVisma")) : ctx.Locale.t("Document.DeleteDesc1", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["documentName", document$.Title]))]])), delay(() => append(document$.IsDeleted ? singleton(MuiHelpers_createElement(Alert, [["severity", "warning"], ["children", ctx.Locale.t("Document.DeletePermanent")]])) : empty(), delay(() => {
        let elems_1, elems;
        return singleton(createElement("div", createObj(ofArray([["style", {
            width: 100 + "%",
            gap: 5 + "px ",
            display: "flex",
            flexDirection: "column",
        }], (elems_1 = [MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("Document.ChooseDeleteReason")], ["select", true], ["defaultValue", ""], ["onChange", (e) => {
            const newReason = e.target.value;
            if (errMsg != null) {
                setErrMsg(undefined);
            }
            if (reasonRef.current != null) {
                const elem = value_63(reasonRef.current);
                if (newReason === ctx.Locale.t("Document.DeleteReasons.Other")) {
                    elem.value = "";
                }
                else {
                    elem.value = newReason;
                }
            }
        }], (elems = map((reason_2) => MuiHelpers_createElement(MenuItem, [["value", reason_2], ["children", reason_2]]), reasons), ["children", reactApi.Children.toArray(Array.from(elems))])]), MuiHelpers_createElement(TextField, [["minRows", 3], ["onFocus", (_arg_5) => {
            if (errMsg != null) {
                setErrMsg(undefined);
            }
        }], ["variant", "outlined"], ["inputRef", reasonRef], ["multiline", true], ["onChange", (e_1) => {
            const _arg_6 = e_1.target.value;
            if (errMsg != null) {
                setErrMsg(undefined);
            }
        }]]), errorBanner(errMsg, () => {
            setErrMsg(undefined);
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elements))])]), (children = toList(delay(() => (patternInput[0] ? singleton(loadingIndicatorSmall()) : append(singleton(MuiHelpers_createElement(Button_1, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_8) => {
        onClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button_1, [["size", "small"], ["variant", "outlined"], ["disabled", errMsg != null], ["children", ctx.Locale.t("Delete")], ["onClick", (_arg_9) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let item, encoder, decoder, data_1, caseStrategy_3, extra_3;
            let reason_1;
            const matchValue = reasonRef.current;
            if (matchValue != null) {
                const reason = matchValue;
                reason_1 = reason.value;
            }
            else {
                reason_1 = "";
            }
            setProcessing(true);
            if (isNullOrWhiteSpace(reason_1)) {
                setErrMsg(ctx.Locale.t("Document.ProvideDeleteReason"));
                setProcessing(false);
                return Promise.resolve();
            }
            else {
                return ((item = {
                    Reason: reason_1,
                }, (encoder = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Reason", string_type]), undefined, undefined, undefined), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(encoder(item)), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                    let properties_2;
                    try {
                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                        const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/document/${document$.Guid}`, properties_3).then((_arg) => {
                            let response_1, decoder_1_1;
                            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                let matchValue_1;
                                return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                        }))));
                        return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                    }
                    catch (exn) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                    }
                })()))))))).then((_arg_2) => {
                    let x_1;
                    const res = _arg_2;
                    return ((res.tag === 1) ? ((setErrMsg(ctx.Locale.t("Document.DeleteFailed")), Promise.resolve())) : ((x_1 = res.fields[0], (x_1.Result === "success") ? ((onClose(document$), Promise.resolve())) : ((setErrMsg(x_1.Message), Promise.resolve()))))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        setProcessing(false);
                        return Promise.resolve();
                    }));
                });
            }
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

export function Button(buttonInputProps) {
    let props_1;
    const document$ = buttonInputProps.document;
    const key = buttonInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const documentDispatch = reactApi.useContext(dispatchCtx);
    const model = reactApi.useContext(documentsCtx);
    const patternInput = reactApi.useState(false);
    const setForm = patternInput[1];
    const tooltipText = document$.IsDeleted ? ctx.Locale.t("Document.DeletedAlready") : ctx.Locale.t("Document.Delete");
    const button = MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        setForm(true);
    }], ["size", "small"], ["children", (props_1 = {}, react.createElement(Delete, props_1))]]);
    const xs = toArray(delay(() => append(patternInput[0] ? singleton(createElement(Form, {
        onClose: (deletedDocOpt) => {
            if (deletedDocOpt != null) {
                const document$_1 = deletedDocOpt;
                const matchValue = model.ViewMode;
                switch (matchValue.tag) {
                    case 2: {
                        documentDispatch(new Message(8, [document$_1.Guid]));
                        break;
                    }
                    case 0: {
                        documentDispatch(new Message(6, [matchValue.fields[0], document$_1.Guid]));
                        break;
                    }
                    case 3: {
                        break;
                    }
                    default:
                        documentDispatch(new Message(7, [document$_1.Guid]));
                }
            }
            else {
                console.debug("Document not deleted: %o", document$);
            }
            setForm(false);
        },
        document: document$,
    })) : empty(), delay(() => singleton(disabledTooltip(tooltipText, button))))));
    return react.createElement(react.Fragment, {}, ...xs);
}

